import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { format } from "date-fns";
import CustomModal from "../../common/CustomModal";
import { DatePicker } from "../../ui/date-picker";
import AdsAPIs from "../../../apiRoutes/Ads";
import { GET_AD_REQUESTS_QUERY_KEY } from "../../../utils/constants/queryKeys";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import toast from "react-hot-toast";

const AssignDeliveryDateModal = ({ open, onClose, requestIds }) => {
  const [date, setDate] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      Promise.all(
        requestIds.map((id) =>
          AdsAPIs.updateAdRequest({ axiosPrivate, id, payload: { due_delivery_date: date ? format(date, "yyyy-MM-dd") : null } })
        )
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GET_AD_REQUESTS_QUERY_KEY });
      toast.success("Delivery date assigned.");
      onClose();
    },
  });

  const handleConfirm = () => {
    if (!date) return toast.error("Select a date.");
    mutate();
  };

  return (
    <CustomModal
      open={open}
      title="Assign delivery date"
      onClose={onClose}
      handleConfirmation={handleConfirm}
      handleConfirmationBtnText="Assign"
      isLoading={isPending}
    >
      <div className="py-1">
        <div className="space-y-2">
          <span className="text-sm font-medium">Due delivery date</span>
          <DatePicker value={date} onChange={setDate} placeholder="Pick a date" />
        </div>
        <p className="text-xs text-muted-foreground mt-2">{requestIds?.length ?? 0} request(s) selected.</p>
      </div>
    </CustomModal>
  );
};

export default AssignDeliveryDateModal;
